import useLocale from 'shared/hooks/useLocale';
import useQuery from 'shared/hooks/useQuery';
import useSessionStorage from 'shared/hooks/useSessionStorage';
import { SESSION_STORAGE_KEYS } from 'shared/sessionStorageUtils';
import { ProductDetailsData } from 'shared/types';

const useGetProductDetails = (productId?: string) => {
  const locale = useLocale();
  const [structure] = useSessionStorage(SESSION_STORAGE_KEYS.structure);
  const params = [locale, structure, productId];

  const { data, error, isLoading, isError } = useQuery<ProductDetailsData>(
    'product-details',
    `v1/products/${structure}/${locale}/${productId}`,
    params
  );

  return {
    productDetails: data,
    error,
    isLoading,
    isError,
  };
};

export default useGetProductDetails;
